import React from 'react';
import PropTypes from 'prop-types';
import BuildChildren from 'utils/BuildChildren';
import classes from './HeroC.module.scss';

const HeroC = (props) => {
  const {
    heading,
    backgroundImageUrl,
    contentMarkup,
    buttons = [],
    isH1,
  } = props;

  // should only set the first hero to h1
  const HeadingTag = isH1 ? 'h1' : 'div';

  return (
    <div className={classes.container}>
      <div
        className={classes.imgContainer}
        style={{ backgroundImage: `url(${backgroundImageUrl})` }}
      />
      <div className={classes.overlay}>
        <div className={classes.wrapper}>
          <div className={classes.contentContainer}>
            {heading &&
              <HeadingTag
                className={classes.title}
                dangerouslySetInnerHTML={{ __html: heading }}
              />}
            {contentMarkup &&
              <div
                className={classes.description}
                dangerouslySetInnerHTML={{ __html: contentMarkup }}
              />}
            {buttons && buttons.length > 0 &&
              <div className={classes.buttons}>
                {buttons.map((button, i) => (
                  <div className={classes.button} key={i}>
                    {BuildChildren(button)}
                  </div>
                ))}
              </div>}
          </div>
        </div>
      </div>
    </div>
  );
};

HeroC.propTypes = {
  /**
   * Text displays at the top of the component
  */
  heading: PropTypes.string,
  /**
   * Text displays below heading
  */
  contentMarkup: PropTypes.string,
  /**
   * Background Image used for component
  */
  backgroundImageUrl: PropTypes.string,
  /**
   * A list of buttons displayed below content markup
  */
  buttons: PropTypes.array,
  /**
  * Make heading H1
  */
  isH1: PropTypes.bool,
};

export default HeroC;
